import React from 'react'
import { ShieldCheckIcon } from '@heroicons/react/24/outline'
import { Button } from 'react-admin'
import { Box, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import { Title } from '../components/Title'
import OrganisationRiskQuestionnaireDirectory from '../Organisations/OrganisationRiskQuestionnaireDirectory'

const QuestionnaireManagement = () => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate('/admin/risk')
  }

  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <Title>Questionnaire Management</Title>
        <div className="p-2 rounded-full bg-white flex items-center justify-center shadow-sm">
          <ShieldCheckIcon className="h-6" />
        </div>
      </div>

      <Button
        onClick={handleBackClick}
        label="Back to Risk Management"
        startIcon={<ArrowBackIcon />}
        className="mb-4"
      />

      <Box
        p={2}
        sx={{ backgroundColor: 'white', borderRadius: '4px', boxShadow: 1 }}
      >
        <Typography variant="h6" gutterBottom>
          Questionnaires Configuration
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Manage questionnaires that will be used for risk assessment. Create,
          edit, and delete questionnaires to customize the information
          collected.
        </Typography>
        <OrganisationRiskQuestionnaireDirectory />
      </Box>
    </section>
  )
}

export default QuestionnaireManagement
